export default __webpack_public_path__ + "static/20-58d439ff08127e54a6c9fd66d91c05f4.webp";